import { ElMessage } from "element-plus";

const downFile = (content, type, file_name = "导出文件") => {
  let blobObj = "";
  switch (type) {
    case 'doc':
      blobObj = new Blob([content], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" //doc
      });
      break;
    case 'pdf':
      blobObj = new Blob([content], {
        type: "application/pdf" //pdf
      });
      break;
    case 'zip':
      blobObj = new Blob([content], {
        type: "application/zip" //zip
      });
      break;
    default:
      blobObj = new Blob([content], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // excel
      });
      break;
  }
  if (window.navigator && window.navigator.msSaveBlob) {
    if (type === 'doc') {
      window.navigator.msSaveBlob(blobObj, `${file_name}.docx`);
    } else if (type === 'pdf') {
      window.navigator.msSaveBlob(blobObj, `${file_name}.pdf`);
    } else if (type === 'zip') {
      window.navigator.msSaveBlob(blobObj, `${file_name}.zip`);
    } else {
      window.navigator.msSaveBlob(blobObj, `${file_name}.xlsx`);
    }
  } else {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const url = window.URL.createObjectURL(blobObj);
    a.href = url;
    a.download = file_name;
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
};

const fileExportResponseError = (data) => {
  const fileReader = new FileReader();
  fileReader.onload = function () {
    try {
      // 说明是普通对象数据，后台转换失败
      const jsonData = JSON.parse(fileReader.result);
      if (jsonData.subCode !== 10002) {
        ElMessage.error(jsonData.subMessage);
      }
    } catch (err) {
      // 解析对象失败，说明是正常的文件流
      console.log(err);
    }
  };
  fileReader.readAsText(data);
}

export default {
  downFile,
  fileExportResponseError
}
